import { isNil, isNumber, min, max } from "lodash";
import { Node } from "../node";

export class AgeValidationNode extends Node {
  get defaults() {
    return {
      ...super.defaults,
      name: "AgeValidationNode",

      answerMode: "age_range",

      question: undefined,

      matchType: "manually",
      minimumAge: undefined,
      maximumAge: undefined,

      inAgeRange: undefined,

      matchTargetNodeId: "continue",
      noMatchTargetNodeId: "continue",

      validateBirthdate: false,
    };
  }

  get isAgeRangeAnswerMode() {
    return this.answerMode === "age_range";
  }

  get currentState() {
    return { inAgeRange: this.inAgeRange };
  }

  get context() {
    return {
      inAgeRange: this.inAgeRange === "true",
      minimumAge: this.minimumAge,
      maximumAge: this.maximumAge,
      ageValidationNodeShown: true,
      validateBirthdate: this.validateBirthdate,
    };
  }

  get possibleNextNodeIds() {
    return [this.matchTargetNodeId, this.noMatchTargetNodeId];
  }

  beforeShow(context) {
    if (this.matchType === "visit_type") {
      this.minimumAge = this.visitTypeAgeRange(context).minimumAge;
      this.maximumAge = this.visitTypeAgeRange(context).maximumAge;
    }

    if (context.minimumAge === this.minimumAge && context.maximumAge === this.maximumAge) {
      this.inAgeRange = context.inAgeRange;
    }
  }

  autoAdvance(context) {
    return this.shouldSkip(context);
  }

  nextNodeId(context) {
    if (this.shouldSkip(context)) {
      return this.matchTargetNodeId;
    }

    if (this.inAgeRange === undefined) {
      return undefined;
    }

    if (this.inAgeRange === "true") {
      return this.matchTargetNodeId;
    }

    return this.noMatchTargetNodeId;
  }

  reset() {
    this.inAgeRange = undefined;
  }

  // PRIVATE

  shouldSkip(context) {
    if (context.ageValidationNodeShown && this.inAgeRange !== undefined) {
      return true;
    }

    if (this.matchType === "visit_type") {
      const visitTypeAgeRange = this.visitTypeAgeRange(context);
      return isNil(visitTypeAgeRange.minimumAge) && isNil(visitTypeAgeRange.maximumAge);
    }

    return false;
  }

  visitTypeAgeRange(context) {
    let minimumAge, maximumAge;

    const providerHasVisitType = context.providerVisitTypeIds.includes(context.visitTypeId);
    const verifyProviderAgeRange = context.visitTypeVerifyProviderAgeRange;

    if (providerHasVisitType && verifyProviderAgeRange) {
      const mergedMinimumAge = max([context.providerMinimumAge, context.visitTypeMinimumAge]);
      const mergedMaximumAge = min([context.providerMaximumAge, context.visitTypeMaximumAge]);

      if (isNumber(mergedMinimumAge) && isNumber(mergedMaximumAge) && mergedMinimumAge >= mergedMaximumAge) {
        minimumAge = undefined;
        maximumAge = undefined;
      } else {
        minimumAge = mergedMinimumAge;
        maximumAge = mergedMaximumAge;
      }
    } else {
      minimumAge = context.visitTypeMinimumAge;
      maximumAge = context.visitTypeMaximumAge;
    }

    return { minimumAge, maximumAge };
  }
}
